import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { activateApprovalRule, getApprovalRuleDetail, getApprovalRules, getDocumentType } from './inventoryApprovalHelper';
import { ApprovalRulesQueryParams } from './inventoryApproval.types';

export const useDocumentTypes = () =>
  useQuery({
    queryKey: ['ApprovalDocumentTypes'],
    queryFn: () => getDocumentType(),
    retry: 1,
    staleTime: 1000 * 60 * 5, // cache 5 min
  });

export const useApprovalRules = (params?: ApprovalRulesQueryParams) =>
  useQuery({
    queryKey: ['ApprovalRules', params],
    queryFn: () => getApprovalRules(params),
    retry: 1,
    staleTime: 1000 * 60 * 2,
  });

export const useApprovalRuleDetail = (id: number | undefined) =>
  useQuery({
    queryKey: ['ApprovalRuleDetail', id],
    queryFn: () => getApprovalRuleDetail(id!),
    enabled: !!id,
    retry: 1,
    staleTime: 1000 * 60 * 2,
  });

export const useToggleApprovalRule = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => activateApprovalRule(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['ApprovalRules'] });
    },
  });
};
